// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../src/assets/fonts/Raleway-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../src/assets/fonts/Raleway-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../src/assets/fonts/Nexa-Bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'Raleway-Medium';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}

@font-face {
    font-family: 'Raleway-Regular';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
}

@font-face {
    font-family: 'Nexa-Bold';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
}

/*
! tailwindcss v3.4.3 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: currentColor; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden] {
  display: none;
}

*, ::before, ::after {
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x:  ;
    --tw-pan-y:  ;
    --tw-pinch-zoom:  ;
    --tw-scroll-snap-strictness: proximity;
    --tw-gradient-from-position:  ;
    --tw-gradient-via-position:  ;
    --tw-gradient-to-position:  ;
    --tw-ordinal:  ;
    --tw-slashed-zero:  ;
    --tw-numeric-figure:  ;
    --tw-numeric-spacing:  ;
    --tw-numeric-fraction:  ;
    --tw-ring-inset:  ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgb(59 130 246 / 0.5);
    --tw-ring-offset-shadow: 0 0 #0000;
    --tw-ring-shadow: 0 0 #0000;
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    --tw-blur:  ;
    --tw-brightness:  ;
    --tw-contrast:  ;
    --tw-grayscale:  ;
    --tw-hue-rotate:  ;
    --tw-invert:  ;
    --tw-saturate:  ;
    --tw-sepia:  ;
    --tw-drop-shadow:  ;
    --tw-backdrop-blur:  ;
    --tw-backdrop-brightness:  ;
    --tw-backdrop-contrast:  ;
    --tw-backdrop-grayscale:  ;
    --tw-backdrop-hue-rotate:  ;
    --tw-backdrop-invert:  ;
    --tw-backdrop-opacity:  ;
    --tw-backdrop-saturate:  ;
    --tw-backdrop-sepia:  ;
    --tw-contain-size:  ;
    --tw-contain-layout:  ;
    --tw-contain-paint:  ;
    --tw-contain-style:  ;
}

::backdrop {
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x:  ;
    --tw-pan-y:  ;
    --tw-pinch-zoom:  ;
    --tw-scroll-snap-strictness: proximity;
    --tw-gradient-from-position:  ;
    --tw-gradient-via-position:  ;
    --tw-gradient-to-position:  ;
    --tw-ordinal:  ;
    --tw-slashed-zero:  ;
    --tw-numeric-figure:  ;
    --tw-numeric-spacing:  ;
    --tw-numeric-fraction:  ;
    --tw-ring-inset:  ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgb(59 130 246 / 0.5);
    --tw-ring-offset-shadow: 0 0 #0000;
    --tw-ring-shadow: 0 0 #0000;
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    --tw-blur:  ;
    --tw-brightness:  ;
    --tw-contrast:  ;
    --tw-grayscale:  ;
    --tw-hue-rotate:  ;
    --tw-invert:  ;
    --tw-saturate:  ;
    --tw-sepia:  ;
    --tw-drop-shadow:  ;
    --tw-backdrop-blur:  ;
    --tw-backdrop-brightness:  ;
    --tw-backdrop-contrast:  ;
    --tw-backdrop-grayscale:  ;
    --tw-backdrop-hue-rotate:  ;
    --tw-backdrop-invert:  ;
    --tw-backdrop-opacity:  ;
    --tw-backdrop-saturate:  ;
    --tw-backdrop-sepia:  ;
    --tw-contain-size:  ;
    --tw-contain-layout:  ;
    --tw-contain-paint:  ;
    --tw-contain-style:  ;
}
.\\!visible {
    visibility: visible !important;
}
.visible {
    visibility: visible;
}
.fixed {
    position: fixed;
}
.absolute {
    position: absolute;
}
.relative {
    position: relative;
}
.-left-64 {
    left: -16rem;
}
.-right-100 {
    right: -25rem;
}
.-right-64 {
    right: -16rem;
}
.-top-80 {
    top: -20rem;
}
.bottom-0 {
    bottom: 0px;
}
.bottom-32 {
    bottom: 8rem;
}
.left-0 {
    left: 0px;
}
.right-0 {
    right: 0px;
}
.top-0 {
    top: 0px;
}
.top-44 {
    top: 11rem;
}
.-z-1 {
    z-index: -1;
}
.-z-2 {
    z-index: -2;
}
.z-10 {
    z-index: 10;
}
.z-20 {
    z-index: 20;
}
.z-50 {
    z-index: 50;
}
.mx-auto {
    margin-left: auto;
    margin-right: auto;
}
.mb-1 {
    margin-bottom: 0.25rem;
}
.mb-10 {
    margin-bottom: 2.5rem;
}
.mb-2 {
    margin-bottom: 0.5rem;
}
.mb-2\\.5 {
    margin-bottom: 0.625rem;
}
.mb-3 {
    margin-bottom: 0.75rem;
}
.mb-4 {
    margin-bottom: 1rem;
}
.mb-4\\.25 {
    margin-bottom: 1.063rem;
}
.mb-6 {
    margin-bottom: 1.5rem;
}
.mr-4 {
    margin-right: 1rem;
}
.mt-7 {
    margin-top: 1.75rem;
}
.mt-7\\.5 {
    margin-top: 1.875rem;
}
.block {
    display: block;
}
.inline-block {
    display: inline-block;
}
.flex {
    display: flex;
}
.grid {
    display: grid;
}
.hidden {
    display: none;
}
.h-11 {
    height: 2.75rem;
}
.h-4 {
    height: 1rem;
}
.h-80 {
    height: 20rem;
}
.h-9 {
    height: 2.25rem;
}
.h-auto {
    height: auto;
}
.h-full {
    height: 100%;
}
.max-h-0 {
    max-height: 0px;
}
.max-h-96 {
    max-height: 24rem;
}
.w-11 {
    width: 2.75rem;
}
.w-4 {
    width: 1rem;
}
.w-9 {
    width: 2.25rem;
}
.w-full {
    width: 100%;
}
.max-w-480 {
    max-width: 120rem;
}
.origin-center {
    transform-origin: center;
}
.-rotate-90 {
    --tw-rotate: -90deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-\\[206deg\\] {
    --tw-rotate: 206deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-\\[327deg\\] {
    --tw-rotate: 327deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.cursor-pointer {
    cursor: pointer;
}
.resize {
    resize: both;
}
.grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
}
.flex-col {
    flex-direction: column;
}
.place-items-center {
    place-items: center;
}
.content-center {
    align-content: center;
}
.content-start {
    align-content: flex-start;
}
.items-center {
    align-items: center;
}
.justify-center {
    justify-content: center;
}
.justify-between {
    justify-content: space-between;
}
.gap-8 {
    gap: 2rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.25rem * var(--tw-space-x-reverse));
    margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-7 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(1.75rem * var(--tw-space-x-reverse));
    margin-left: calc(1.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-7\\.5 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(1.875rem * var(--tw-space-x-reverse));
    margin-left: calc(1.875rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-16 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(4rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(4rem * var(--tw-space-y-reverse));
}
.space-y-16\\.5 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(4.125rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(4.125rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.overflow-auto {
    overflow: auto;
}
.overflow-hidden {
    overflow: hidden;
}
.overflow-y-auto {
    overflow-y: auto;
}
.whitespace-nowrap {
    white-space: nowrap;
}
.rounded {
    border-radius: 0.25rem;
}
.rounded-2xl {
    border-radius: 1rem;
}
.rounded-3 {
    border-radius: 0.75rem;
}
.rounded-full {
    border-radius: 9999px;
}
.rounded-lg {
    border-radius: 0.5rem;
}
.rounded-xl {
    border-radius: 0.75rem;
}
.border {
    border-width: 1px;
}
.border-b {
    border-bottom-width: 1px;
}
.border-t {
    border-top-width: 1px;
}
.border-none {
    border-style: none;
}
.border-dark-gray {
    --tw-border-opacity: 1;
    border-color: rgb(40 40 40 / var(--tw-border-opacity));
}
.border-light-gray {
    --tw-border-opacity: 1;
    border-color: rgb(205 205 205 / var(--tw-border-opacity));
}
.border-red {
    --tw-border-opacity: 1;
    border-color: rgb(149 31 29 / var(--tw-border-opacity));
}
.border-b-light-gray {
    --tw-border-opacity: 1;
    border-bottom-color: rgb(205 205 205 / var(--tw-border-opacity));
}
.border-t-light-gray {
    --tw-border-opacity: 1;
    border-top-color: rgb(205 205 205 / var(--tw-border-opacity));
}
.bg-black {
    --tw-bg-opacity: 1;
    background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.bg-dark-gray {
    --tw-bg-opacity: 1;
    background-color: rgb(40 40 40 / var(--tw-bg-opacity));
}
.bg-light-gray {
    --tw-bg-opacity: 1;
    background-color: rgb(205 205 205 / var(--tw-bg-opacity));
}
.bg-pink {
    --tw-bg-opacity: 1;
    background-color: rgb(243 220 219 / var(--tw-bg-opacity));
}
.bg-red {
    --tw-bg-opacity: 1;
    background-color: rgb(149 31 29 / var(--tw-bg-opacity));
}
.bg-tiny-gray {
    --tw-bg-opacity: 1;
    background-color: rgb(249 249 249 / var(--tw-bg-opacity));
}
.bg-white {
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-opacity-75 {
    --tw-bg-opacity: 0.75;
}
.object-contain {
    object-fit: contain;
}
.object-cover {
    object-fit: cover;
}
.object-top {
    object-position: top;
}
.px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
}
.px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
}
.px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
}
.py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
}
.py-5 {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
}
.pb-12 {
    padding-bottom: 3rem;
}
.pb-12\\.5 {
    padding-bottom: 3.125rem;
}
.pb-6 {
    padding-bottom: 1.5rem;
}
.pl-1 {
    padding-left: 0.25rem;
}
.pr-1 {
    padding-right: 0.25rem;
}
.pt-26\\.5 {
    padding-top: 6.625rem;
}
.pt-6 {
    padding-top: 1.5rem;
}
.text-center {
    text-align: center;
}
.text-start {
    text-align: start;
}
.font-nexa-bold {
    font-family: Nexa-Bold, sans-serif;
}
.font-raleway-medium {
    font-family: Raleway-Medium, sans-serif;
}
.font-raleway-regular {
    font-family: Raleway-Regular, sans-serif;
}
.text-3 {
    font-size: 0.75rem;
}
.text-3\\.5 {
    font-size: 0.875rem;
}
.text-4 {
    font-size: 1rem;
}
.text-5 {
    font-size: 1.25rem;
}
.text-8 {
    font-size: 2rem;
}
.text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
}
.text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
}
.text-black {
    --tw-text-opacity: 1;
    color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-dark-gray {
    --tw-text-opacity: 1;
    color: rgb(40 40 40 / var(--tw-text-opacity));
}
.text-gray {
    --tw-text-opacity: 1;
    color: rgb(119 119 119 / var(--tw-text-opacity));
}
.text-red {
    --tw-text-opacity: 1;
    color: rgb(149 31 29 / var(--tw-text-opacity));
}
.text-white {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity));
}
.placeholder-light-gray::placeholder {
    --tw-placeholder-opacity: 1;
    color: rgb(205 205 205 / var(--tw-placeholder-opacity));
}
.opacity-50 {
    opacity: 0.5;
}
.backdrop-blur-sm {
    --tw-backdrop-blur: blur(4px);
    -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
            backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.transition-all {
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.duration-300 {
    transition-duration: 300ms;
}
.h-mobile {
        height: calc(100vh - 4.75rem);
    }

.service:hover {
    svg {
        path {
            fill: #951F1D;
        }
    }
}

.price {
    svg {
        circle {
            fill: white;
        }
    }
}

@keyframes marquee {
    0% {
        transform: translateX(0);
    }
    100% {
        transform: translateX(-100%);
    }
}

.animate-marquee {
    animation: marquee 30s linear infinite;
    white-space: nowrap;
}

.header-list {
    margin-bottom: 6.6rem;
}

@media (max-width: 320px) {
    .mobile-bg {
        clip-path: polygon(0 154%, 100% 0, 100% 100%, 0% 100%);
    }
}

@media (max-width: 576px) {
    .mobile-bg {
        clip-path: polygon(0 87%, 100% 0, 100% 100%, 0% 100%);
    }
}

@media (max-width: 768px) {
    .mobile-bg {
        clip-path: polygon(0 77%, 100% 0, 100% 100%, 0% 100%);
    }
}

.slick-arrow {
    display: none !important;
}

@media (max-width: 768px) {
    .slide {
        width: 100% !important;
        display: flex !important;
    }
}

@media (min-width: 769px) {
    .slide {
        max-width: 47.8rem !important;
        display: flex !important;
    }
}

.slick-disable {
    .slide-button {
        background: #000;
    }
}

.current-slide {
    z-index: 20;
}

.select-placeholder-text {
    color: pink;
}

.pac-container {
    position: fixed !important;
    z-index: 1000;
}

a {
    color: #951F1D;
}

li > a {
    color: #777777;
}

li > a:hover {
    color: #951F1D;
}

.hover\\:cursor-pointer:hover {
    cursor: pointer;
}

.hover\\:border-red:hover {
    --tw-border-opacity: 1;
    border-color: rgb(149 31 29 / var(--tw-border-opacity));
}

.hover\\:bg-black:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}

.hover\\:bg-dark-gray:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(40 40 40 / var(--tw-bg-opacity));
}

.hover\\:bg-pink:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(243 220 219 / var(--tw-bg-opacity));
}

.hover\\:bg-white:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.hover\\:text-black:hover {
    --tw-text-opacity: 1;
    color: rgb(0 0 0 / var(--tw-text-opacity));
}

.hover\\:text-dark-gray:hover {
    --tw-text-opacity: 1;
    color: rgb(40 40 40 / var(--tw-text-opacity));
}

.hover\\:text-red:hover {
    --tw-text-opacity: 1;
    color: rgb(149 31 29 / var(--tw-text-opacity));
}

.hover\\:text-white:hover {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity));
}

.focus\\:border-red:focus {
    --tw-border-opacity: 1;
    border-color: rgb(149 31 29 / var(--tw-border-opacity));
}

.group:hover .group-hover\\:bg-white {
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.group:hover .group-hover\\:text-black {
    --tw-text-opacity: 1;
    color: rgb(0 0 0 / var(--tw-text-opacity));
}

@media (min-width: 320px) {

    .xs\\:bottom-0 {
        bottom: 0px;
    }

    .xs\\:bottom-5 {
        bottom: 1.25rem;
    }

    .xs\\:left-0 {
        left: 0px;
    }

    .xs\\:right-0 {
        right: 0px;
    }

    .xs\\:right-4 {
        right: 1rem;
    }

    .xs\\:top-22\\.5 {
        top: 5.625rem;
    }

    .xs\\:top-4 {
        top: 1rem;
    }

    .xs\\:mx-6 {
        margin-left: 1.5rem;
        margin-right: 1.5rem;
    }

    .xs\\:mb-15 {
        margin-bottom: 3.75rem;
    }

    .xs\\:mb-2 {
        margin-bottom: 0.5rem;
    }

    .xs\\:mb-2\\.5 {
        margin-bottom: 0.625rem;
    }

    .xs\\:mb-3 {
        margin-bottom: 0.75rem;
    }

    .xs\\:mb-3\\.5 {
        margin-bottom: 0.875rem;
    }

    .xs\\:mb-4 {
        margin-bottom: 1rem;
    }

    .xs\\:mb-6 {
        margin-bottom: 1.5rem;
    }

    .xs\\:mr-2 {
        margin-right: 0.5rem;
    }

    .xs\\:mt-11 {
        margin-top: 2.75rem;
    }

    .xs\\:mt-11\\.25 {
        margin-top: 2.813rem;
    }

    .xs\\:mt-15 {
        margin-top: 3.75rem;
    }

    .xs\\:mt-22\\.5 {
        margin-top: 5.625rem;
    }

    .xs\\:mt-7 {
        margin-top: 1.75rem;
    }

    .xs\\:mt-7\\.5 {
        margin-top: 1.875rem;
    }

    .xs\\:flex {
        display: flex;
    }

    .xs\\:h-10 {
        height: 2.5rem;
    }

    .xs\\:h-168\\.75 {
        height: 42.188rem;
    }

    .xs\\:h-20 {
        height: 5rem;
    }

    .xs\\:h-3 {
        height: 0.75rem;
    }

    .xs\\:h-3\\.058 {
        height: 0.764rem;
    }

    .xs\\:h-4 {
        height: 1rem;
    }

    .xs\\:h-71\\.5 {
        height: 17.875rem;
    }

    .xs\\:h-81\\.5 {
        height: 20.375rem;
    }

    .xs\\:h-9 {
        height: 2.25rem;
    }

    .xs\\:h-99\\.5 {
        height: 24.875rem;
    }

    .xs\\:max-h-full {
        max-height: 100%;
    }

    .xs\\:w-191\\.25 {
        width: 47.813rem;
    }

    .xs\\:w-20 {
        width: 5rem;
    }

    .xs\\:w-3 {
        width: 0.75rem;
    }

    .xs\\:w-3\\.058 {
        width: 0.764rem;
    }

    .xs\\:w-4 {
        width: 1rem;
    }

    .xs\\:w-52 {
        width: 13rem;
    }

    .xs\\:w-60 {
        width: 15rem;
    }

    .xs\\:w-64 {
        width: 16rem;
    }

    .xs\\:w-full {
        width: 100%;
    }

    .xs\\:flex-col {
        flex-direction: column;
    }

    .xs\\:content-center {
        align-content: center;
    }

    .xs\\:items-center {
        align-items: center;
    }

    .xs\\:justify-start {
        justify-content: flex-start;
    }

    .xs\\:justify-center {
        justify-content: center;
    }

    .xs\\:space-x-0 > :not([hidden]) ~ :not([hidden]) {
        --tw-space-x-reverse: 0;
        margin-right: calc(0px * var(--tw-space-x-reverse));
        margin-left: calc(0px * calc(1 - var(--tw-space-x-reverse)));
    }

    .xs\\:space-y-6 > :not([hidden]) ~ :not([hidden]) {
        --tw-space-y-reverse: 0;
        margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
        margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
    }

    .xs\\:space-y-7 > :not([hidden]) ~ :not([hidden]) {
        --tw-space-y-reverse: 0;
        margin-top: calc(1.75rem * calc(1 - var(--tw-space-y-reverse)));
        margin-bottom: calc(1.75rem * var(--tw-space-y-reverse));
    }

    .xs\\:space-y-7\\.5 > :not([hidden]) ~ :not([hidden]) {
        --tw-space-y-reverse: 0;
        margin-top: calc(1.875rem * calc(1 - var(--tw-space-y-reverse)));
        margin-bottom: calc(1.875rem * var(--tw-space-y-reverse));
    }

    .xs\\:rounded {
        border-radius: 0.25rem;
    }

    .xs\\:px-4 {
        padding-left: 1rem;
        padding-right: 1rem;
    }

    .xs\\:px-6 {
        padding-left: 1.5rem;
        padding-right: 1.5rem;
    }

    .xs\\:py-10 {
        padding-top: 2.5rem;
        padding-bottom: 2.5rem;
    }

    .xs\\:py-4 {
        padding-top: 1rem;
        padding-bottom: 1rem;
    }

    .xs\\:py-4\\.25 {
        padding-top: 1.063rem;
        padding-bottom: 1.063rem;
    }

    .xs\\:pb-6 {
        padding-bottom: 1.5rem;
    }

    .xs\\:pt-12 {
        padding-top: 3rem;
    }

    .xs\\:text-center {
        text-align: center;
    }

    .xs\\:text-12 {
        font-size: 3rem;
    }

    .xs\\:text-3 {
        font-size: 0.75rem;
    }

    .xs\\:text-3\\.5 {
        font-size: 0.875rem;
    }

    .xs\\:text-4 {
        font-size: 1rem;
    }

    .xs\\:text-5 {
        font-size: 1.25rem;
    }

    .xs\\:text-6 {
        font-size: 1.5rem;
    }

    .xs\\:text-8 {
        font-size: 2rem;
    }
}

@media (min-width: 576px) {

    .sm\\:h-146\\.5 {
        height: 36.625rem;
    }
}

@media (min-width: 768px) {

    .md\\:mt-30 {
        margin-top: 7.5rem;
    }

    .md\\:h-168\\.75 {
        height: 42.188rem;
    }

    .md\\:h-4 {
        height: 1rem;
    }

    .md\\:h-4\\.375 {
        height: 1.094rem;
    }

    .md\\:h-6 {
        height: 1.5rem;
    }

    .md\\:h-72 {
        height: 18rem;
    }

    .md\\:w-138\\.333 {
        width: 34.583rem;
    }

    .md\\:w-177\\.75 {
        width: 44.438rem;
    }

    .md\\:w-4 {
        width: 1rem;
    }

    .md\\:w-4\\.375 {
        width: 1.094rem;
    }

    .md\\:w-6 {
        width: 1.5rem;
    }

    .md\\:px-4 {
        padding-left: 1rem;
        padding-right: 1rem;
    }

    .md\\:px-6 {
        padding-left: 1.5rem;
        padding-right: 1.5rem;
    }

    .md\\:py-10 {
        padding-top: 2.5rem;
        padding-bottom: 2.5rem;
    }

    .md\\:text-4 {
        font-size: 1rem;
    }

    .md\\:text-5 {
        font-size: 1.25rem;
    }

    .md\\:text-6 {
        font-size: 1.5rem;
    }
}

@media (min-width: 1024px) {

    .lg\\:absolute {
        position: absolute;
    }

    .lg\\:-bottom-10 {
        bottom: -2.5rem;
    }

    .lg\\:-left-40 {
        left: -10rem;
    }

    .lg\\:-right-64 {
        right: -16rem;
    }

    .lg\\:bottom-0 {
        bottom: 0px;
    }

    .lg\\:bottom-0\\.5 {
        bottom: 0.125rem;
    }

    .lg\\:bottom-7 {
        bottom: 1.75rem;
    }

    .lg\\:right-7 {
        right: 1.75rem;
    }

    .lg\\:right-7\\.5 {
        right: 1.875rem;
    }

    .lg\\:top-28 {
        top: 7rem;
    }

    .lg\\:top-44 {
        top: 11rem;
    }

    .lg\\:top-7 {
        top: 1.75rem;
    }

    .lg\\:top-7\\.5 {
        top: 1.875rem;
    }

    .lg\\:mx-0 {
        margin-left: 0px;
        margin-right: 0px;
    }

    .lg\\:mb-10 {
        margin-bottom: 2.5rem;
    }

    .lg\\:mb-2 {
        margin-bottom: 0.5rem;
    }

    .lg\\:mb-2\\.5 {
        margin-bottom: 0.625rem;
    }

    .lg\\:mb-30 {
        margin-bottom: 7.5rem;
    }

    .lg\\:mb-32 {
        margin-bottom: 8rem;
    }

    .lg\\:mb-6 {
        margin-bottom: 1.5rem;
    }

    .lg\\:mb-7 {
        margin-bottom: 1.75rem;
    }

    .lg\\:mb-7\\.5 {
        margin-bottom: 1.875rem;
    }

    .lg\\:ml-8 {
        margin-left: 2rem;
    }

    .lg\\:mt-0 {
        margin-top: 0px;
    }

    .lg\\:mt-15 {
        margin-top: 3.75rem;
    }

    .lg\\:mt-24 {
        margin-top: 6rem;
    }

    .lg\\:mt-30 {
        margin-top: 7.5rem;
    }

    .lg\\:flex {
        display: flex;
    }

    .lg\\:h-108 {
        height: 27rem;
    }

    .lg\\:h-116\\.5 {
        height: 29.125rem;
    }

    .lg\\:h-146\\.5 {
        height: 36.625rem;
    }

    .lg\\:h-17 {
        height: 4.25rem;
    }

    .lg\\:h-77\\.25 {
        height: 19.313rem;
    }

    .lg\\:h-99\\.5 {
        height: 24.875rem;
    }

    .lg\\:h-full {
        height: 100%;
    }

    .lg\\:max-h-full {
        max-height: 100%;
    }

    .lg\\:w-100 {
        width: 25rem;
    }

    .lg\\:w-191\\.25 {
        width: 47.813rem;
    }

    .lg\\:w-204 {
        width: 51rem;
    }

    .lg\\:w-211\\.25 {
        width: 52.813rem;
    }

    .lg\\:w-48 {
        width: 12rem;
    }

    .lg\\:w-77\\.75 {
        width: 19.438rem;
    }

    .lg\\:w-96 {
        width: 24rem;
    }

    .lg\\:-rotate-45 {
        --tw-rotate: -45deg;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    }

    .lg\\:rotate-\\[327deg\\] {
        --tw-rotate: 327deg;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    }

    .lg\\:flex-row {
        flex-direction: row;
    }

    .lg\\:flex-col {
        flex-direction: column;
    }

    .lg\\:content-start {
        align-content: flex-start;
    }

    .lg\\:justify-end {
        justify-content: flex-end;
    }

    .lg\\:justify-center {
        justify-content: center;
    }

    .lg\\:space-x-4 > :not([hidden]) ~ :not([hidden]) {
        --tw-space-x-reverse: 0;
        margin-right: calc(1rem * var(--tw-space-x-reverse));
        margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
    }

    .lg\\:space-x-7 > :not([hidden]) ~ :not([hidden]) {
        --tw-space-x-reverse: 0;
        margin-right: calc(1.75rem * var(--tw-space-x-reverse));
        margin-left: calc(1.75rem * calc(1 - var(--tw-space-x-reverse)));
    }

    .lg\\:space-x-7\\.5 > :not([hidden]) ~ :not([hidden]) {
        --tw-space-x-reverse: 0;
        margin-right: calc(1.875rem * var(--tw-space-x-reverse));
        margin-left: calc(1.875rem * calc(1 - var(--tw-space-x-reverse)));
    }

    .lg\\:space-y-0 > :not([hidden]) ~ :not([hidden]) {
        --tw-space-y-reverse: 0;
        margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
        margin-bottom: calc(0px * var(--tw-space-y-reverse));
    }

    .lg\\:rounded-5 {
        border-radius: 1.25rem;
    }

    .lg\\:px-0 {
        padding-left: 0px;
        padding-right: 0px;
    }

    .lg\\:px-10 {
        padding-left: 2.5rem;
        padding-right: 2.5rem;
    }

    .lg\\:px-16 {
        padding-left: 4rem;
        padding-right: 4rem;
    }

    .lg\\:px-36 {
        padding-left: 9rem;
        padding-right: 9rem;
    }

    .lg\\:px-36\\.5 {
        padding-left: 9.125rem;
        padding-right: 9.125rem;
    }

    .lg\\:px-4 {
        padding-left: 1rem;
        padding-right: 1rem;
    }

    .lg\\:py-10 {
        padding-top: 2.5rem;
        padding-bottom: 2.5rem;
    }

    .lg\\:py-15 {
        padding-top: 3.75rem;
        padding-bottom: 3.75rem;
    }

    .lg\\:py-25 {
        padding-top: 6.25rem;
        padding-bottom: 6.25rem;
    }

    .lg\\:py-5 {
        padding-top: 1.25rem;
        padding-bottom: 1.25rem;
    }

    .lg\\:pr-0 {
        padding-right: 0px;
    }

    .lg\\:pt-16 {
        padding-top: 4rem;
    }

    .lg\\:text-center {
        text-align: center;
    }

    .lg\\:text-12 {
        font-size: 3rem;
    }

    .lg\\:text-14 {
        font-size: 3rem;
    }

    .lg\\:text-16 {
        font-size: 4rem;
    }

    .lg\\:text-4 {
        font-size: 1rem;
    }

    .lg\\:text-5 {
        font-size: 1.25rem;
    }

    .lg\\:text-6 {
        font-size: 1.5rem;
    }

    .lg\\:text-7 {
        font-size: 1.75rem;
    }

    .lg\\:text-9 {
        font-size: 2.25rem;
    }

    .lg\\:text-current {
        color: currentColor;
    }
}

@media (min-width: 1280px) {

    .xl\\:mb-6 {
        margin-bottom: 1.5rem;
    }

    .xl\\:ml-14 {
        margin-left: 3.5rem;
    }

    .xl\\:h-116\\.5 {
        height: 29.125rem;
    }

    .xl\\:h-130 {
        height: 32.5rem;
    }

    .xl\\:h-27\\.5 {
        height: 6.875rem;
    }

    .xl\\:h-auto {
        height: auto;
    }

    .xl\\:w-138\\.333 {
        width: 34.583rem;
    }

    .xl\\:w-177\\.75 {
        width: 44.438rem;
    }

    .xl\\:w-191\\.25 {
        width: 47.813rem;
    }

    .xl\\:w-27\\.5 {
        width: 6.875rem;
    }

    .xl\\:w-284 {
        width: 71rem;
    }

    .xl\\:grid-cols-2 {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .xl\\:content-start {
        align-content: flex-start;
    }

    .xl\\:items-start {
        align-items: flex-start;
    }

    .xl\\:space-x-8 > :not([hidden]) ~ :not([hidden]) {
        --tw-space-x-reverse: 0;
        margin-right: calc(2rem * var(--tw-space-x-reverse));
        margin-left: calc(2rem * calc(1 - var(--tw-space-x-reverse)));
    }

    .xl\\:px-25 {
        padding-left: 6.25rem;
        padding-right: 6.25rem;
    }

    .xl\\:px-36 {
        padding-left: 9rem;
        padding-right: 9rem;
    }

    .xl\\:px-36\\.5 {
        padding-left: 9.125rem;
        padding-right: 9.125rem;
    }

    .xl\\:py-16 {
        padding-top: 4rem;
        padding-bottom: 4rem;
    }

    .xl\\:py-25 {
        padding-top: 6.25rem;
        padding-bottom: 6.25rem;
    }

    .xl\\:pl-10 {
        padding-left: 2.5rem;
    }

    .xl\\:pl-25 {
        padding-left: 6.25rem;
    }

    .xl\\:pr-22\\.082 {
        padding-right: 5.521rem;
    }

    .xl\\:text-start {
        text-align: start;
    }

    .xl\\:text-16 {
        font-size: 4rem;
    }

    .xl\\:text-5 {
        font-size: 1.25rem;
    }

    .xl\\:text-6 {
        font-size: 1.5rem;
    }

    .xl\\:text-8 {
        font-size: 2rem;
    }
}

@media (min-width: 1536px) {

    .\\32xl\\:mb-10 {
        margin-bottom: 2.5rem;
    }

    .\\32xl\\:ml-32 {
        margin-left: 8rem;
    }

    .\\32xl\\:ml-32\\.75 {
        margin-left: 8.188rem;
    }

    .\\32xl\\:mr-4 {
        margin-right: 1rem;
    }

    .\\32xl\\:h-116\\.5 {
        height: 29.125rem;
    }

    .\\32xl\\:h-205 {
        height: 51.25rem;
    }

    .\\32xl\\:w-116\\.5 {
        width: 29.125rem;
    }

    .\\32xl\\:w-138\\.333 {
        width: 34.583rem;
    }

    .\\32xl\\:w-174\\.75 {
        width: 43.688rem;
    }

    .\\32xl\\:w-357 {
        width: 89.25rem;
    }

    .\\32xl\\:w-77\\.75 {
        width: 19.438rem;
    }

    .\\32xl\\:flex-row {
        flex-direction: row;
    }

    .\\32xl\\:space-x-14 > :not([hidden]) ~ :not([hidden]) {
        --tw-space-x-reverse: 0;
        margin-right: calc(3.5rem * var(--tw-space-x-reverse));
        margin-left: calc(3.5rem * calc(1 - var(--tw-space-x-reverse)));
    }

    .\\32xl\\:px-15 {
        padding-left: 3.75rem;
        padding-right: 3.75rem;
    }

    .\\32xl\\:px-36 {
        padding-left: 9rem;
        padding-right: 9rem;
    }

    .\\32xl\\:px-36\\.5 {
        padding-left: 9.125rem;
        padding-right: 9.125rem;
    }

    .\\32xl\\:py-20 {
        padding-top: 5rem;
        padding-bottom: 5rem;
    }

    .\\32xl\\:py-25 {
        padding-top: 6.25rem;
        padding-bottom: 6.25rem;
    }

    .\\32xl\\:py-6 {
        padding-top: 1.5rem;
        padding-bottom: 1.5rem;
    }

    .\\32xl\\:text-16 {
        font-size: 4rem;
    }

    .\\32xl\\:text-4 {
        font-size: 1rem;
    }

    .\\32xl\\:text-5 {
        font-size: 1.25rem;
    }

    .\\32xl\\:text-6 {
        font-size: 1.5rem;
    }
}

@media (min-width: 1920px) {

    .\\33xl\\:mb-6 {
        margin-bottom: 1.5rem;
    }

    .\\33xl\\:mt-0 {
        margin-top: 0px;
    }

    .\\33xl\\:h-auto {
        height: auto;
    }

    .\\33xl\\:w-163\\.25 {
        width: 40.813rem;
    }

    .\\33xl\\:w-211\\.25 {
        width: 52.813rem;
    }

    .\\33xl\\:space-x-16 > :not([hidden]) ~ :not([hidden]) {
        --tw-space-x-reverse: 0;
        margin-right: calc(4rem * var(--tw-space-x-reverse));
        margin-left: calc(4rem * calc(1 - var(--tw-space-x-reverse)));
    }

    .\\33xl\\:space-x-16\\.5 > :not([hidden]) ~ :not([hidden]) {
        --tw-space-x-reverse: 0;
        margin-right: calc(4.125rem * var(--tw-space-x-reverse));
        margin-left: calc(4.125rem * calc(1 - var(--tw-space-x-reverse)));
    }

    .\\33xl\\:text-20 {
        font-size: 5rem;
    }

    .\\33xl\\:text-5 {
        font-size: 1.25rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,+DAAqE;AACzE;;AAEA;IACI,8BAA8B;IAC9B,+DAAsE;AAC1E;;AAEA;IACI,wBAAwB;IACxB,+DAAgE;AACpE;;AAEA;;CAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,0BAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;IAAA,wBAAc;IAAd,wBAAc;IAAd,mBAAc;IAAd,mBAAc;IAAd,cAAc;IAAd,cAAc;IAAd,cAAc;IAAd,eAAc;IAAd,eAAc;IAAd,aAAc;IAAd,aAAc;IAAd,kBAAc;IAAd,sCAAc;IAAd,8BAAc;IAAd,6BAAc;IAAd,4BAAc;IAAd,eAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,kBAAc;IAAd,2BAAc;IAAd,4BAAc;IAAd,sCAAc;IAAd,kCAAc;IAAd,2BAAc;IAAd,sBAAc;IAAd,8BAAc;IAAd,YAAc;IAAd,kBAAc;IAAd,gBAAc;IAAd,iBAAc;IAAd,kBAAc;IAAd,cAAc;IAAd,gBAAc;IAAd,aAAc;IAAd,mBAAc;IAAd,qBAAc;IAAd,2BAAc;IAAd,yBAAc;IAAd,0BAAc;IAAd,2BAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,yBAAc;IAAd,sBAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,qBAAc;IAAd;AAAc;;AAAd;IAAA,wBAAc;IAAd,wBAAc;IAAd,mBAAc;IAAd,mBAAc;IAAd,cAAc;IAAd,cAAc;IAAd,cAAc;IAAd,eAAc;IAAd,eAAc;IAAd,aAAc;IAAd,aAAc;IAAd,kBAAc;IAAd,sCAAc;IAAd,8BAAc;IAAd,6BAAc;IAAd,4BAAc;IAAd,eAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,kBAAc;IAAd,2BAAc;IAAd,4BAAc;IAAd,sCAAc;IAAd,kCAAc;IAAd,2BAAc;IAAd,sBAAc;IAAd,8BAAc;IAAd,YAAc;IAAd,kBAAc;IAAd,gBAAc;IAAd,iBAAc;IAAd,kBAAc;IAAd,cAAc;IAAd,gBAAc;IAAd,aAAc;IAAd,mBAAc;IAAd,qBAAc;IAAd,2BAAc;IAAd,yBAAc;IAAd,0BAAc;IAAd,2BAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,yBAAc;IAAd,sBAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,qBAAc;IAAd;AAAc;AAEd;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,uDAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,uDAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,4DAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,gEAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,+DAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,8DAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,2BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB,+QAAmB;YAAnB;AAAmB;AAAnB;IAAA,gKAAmB;IAAnB,wJAAmB;IAAnB,iLAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,wBAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAiCf;QACI,6BAA6B;IACjC;;AAjCJ;IACI;QACI;YACI,aAAa;QACjB;IACJ;AACJ;;AAEA;IACI;QACI;YACI,WAAW;QACf;IACJ;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI,sCAAsC;IACtC,mBAAmB;AACvB;;AAYA;IACI,qBAAqB;AACzB;;AAEA;IACI;QACI,sDAAsD;IAC1D;AACJ;;AAEA;IACI;QACI,qDAAqD;IACzD;AACJ;;AAEA;IACI;QACI,qDAAqD;IACzD;AACJ;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI;QACI,sBAAsB;QACtB,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,6BAA6B;QAC7B,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAhIA;IAAA;AAiIA;;AAjIA;IAAA,sBAiIA;IAjIA;AAiIA;;AAjIA;IAAA,kBAiIA;IAjIA;AAiIA;;AAjIA;IAAA,kBAiIA;IAjIA;AAiIA;;AAjIA;IAAA,kBAiIA;IAjIA;AAiIA;;AAjIA;IAAA,kBAiIA;IAjIA;AAiIA;;AAjIA;IAAA,oBAiIA;IAjIA;AAiIA;;AAjIA;IAAA,oBAiIA;IAjIA;AAiIA;;AAjIA;IAAA,oBAiIA;IAjIA;AAiIA;;AAjIA;IAAA,oBAiIA;IAjIA;AAiIA;;AAjIA;IAAA,sBAiIA;IAjIA;AAiIA;;AAjIA;IAAA,kBAiIA;IAjIA;AAiIA;;AAjIA;IAAA,oBAiIA;IAjIA;AAiIA;;AAjIA;;IAAA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA,mBAiIA;QAjIA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA,uBAiIA;QAjIA,mDAiIA;QAjIA;IAiIA;;IAjIA;QAAA,uBAiIA;QAjIA,8DAiIA;QAjIA;IAiIA;;IAjIA;QAAA,uBAiIA;QAjIA,+DAiIA;QAjIA;IAiIA;;IAjIA;QAAA,uBAiIA;QAjIA,gEAiIA;QAjIA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA,kBAiIA;QAjIA;IAiIA;;IAjIA;QAAA,oBAiIA;QAjIA;IAiIA;;IAjIA;QAAA,mBAiIA;QAjIA;IAiIA;;IAjIA;QAAA,iBAiIA;QAjIA;IAiIA;;IAjIA;QAAA,qBAiIA;QAjIA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;AAAA;;AAjIA;;IAAA;QAAA;IAiIA;AAAA;;AAjIA;;IAAA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA,kBAiIA;QAjIA;IAiIA;;IAjIA;QAAA,oBAiIA;QAjIA;IAiIA;;IAjIA;QAAA,mBAiIA;QAjIA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;AAAA;;AAjIA;;IAAA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA,gBAiIA;QAjIA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA,mBAiIA;QAjIA;IAiIA;;IAjIA;QAAA,mBAiIA;QAjIA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA,uBAiIA;QAjIA,oDAiIA;QAjIA;IAiIA;;IAjIA;QAAA,uBAiIA;QAjIA,uDAiIA;QAjIA;IAiIA;;IAjIA;QAAA,uBAiIA;QAjIA,wDAiIA;QAjIA;IAiIA;;IAjIA;QAAA,uBAiIA;QAjIA,2DAiIA;QAjIA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA,iBAiIA;QAjIA;IAiIA;;IAjIA;QAAA,oBAiIA;QAjIA;IAiIA;;IAjIA;QAAA,kBAiIA;QAjIA;IAiIA;;IAjIA;QAAA,kBAiIA;QAjIA;IAiIA;;IAjIA;QAAA,sBAiIA;QAjIA;IAiIA;;IAjIA;QAAA,kBAiIA;QAjIA;IAiIA;;IAjIA;QAAA,mBAiIA;QAjIA;IAiIA;;IAjIA;QAAA,oBAiIA;QAjIA;IAiIA;;IAjIA;QAAA,oBAiIA;QAjIA;IAiIA;;IAjIA;QAAA,oBAiIA;QAjIA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;AAAA;;AAjIA;;IAAA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA,uBAiIA;QAjIA,oDAiIA;QAjIA;IAiIA;;IAjIA;QAAA,qBAiIA;QAjIA;IAiIA;;IAjIA;QAAA,kBAiIA;QAjIA;IAiIA;;IAjIA;QAAA,sBAiIA;QAjIA;IAiIA;;IAjIA;QAAA,iBAiIA;QAjIA;IAiIA;;IAjIA;QAAA,oBAiIA;QAjIA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;AAAA;;AAjIA;;IAAA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA,uBAiIA;QAjIA,sDAiIA;QAjIA;IAiIA;;IAjIA;QAAA,qBAiIA;QAjIA;IAiIA;;IAjIA;QAAA,kBAiIA;QAjIA;IAiIA;;IAjIA;QAAA,sBAiIA;QAjIA;IAiIA;;IAjIA;QAAA,iBAiIA;QAjIA;IAiIA;;IAjIA;QAAA,oBAiIA;QAjIA;IAiIA;;IAjIA;QAAA,mBAiIA;QAjIA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;AAAA;;AAjIA;;IAAA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA,uBAiIA;QAjIA,oDAiIA;QAjIA;IAiIA;;IAjIA;QAAA,uBAiIA;QAjIA,wDAiIA;QAjIA;IAiIA;;IAjIA;QAAA;IAiIA;;IAjIA;QAAA;IAiIA;AAAA","sourcesContent":["@font-face {\n    font-family: 'Raleway-Medium';\n    src: url('../src/assets/fonts/Raleway-Medium.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'Raleway-Regular';\n    src: url('../src/assets/fonts/Raleway-Regular.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'Nexa-Bold';\n    src: url('../src/assets/fonts/Nexa-Bold.ttf') format('truetype');\n}\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n.service:hover {\n    svg {\n        path {\n            fill: #951F1D;\n        }\n    }\n}\n\n.price {\n    svg {\n        circle {\n            fill: white;\n        }\n    }\n}\n\n@keyframes marquee {\n    0% {\n        transform: translateX(0);\n    }\n    100% {\n        transform: translateX(-100%);\n    }\n}\n\n.animate-marquee {\n    animation: marquee 30s linear infinite;\n    white-space: nowrap;\n}\n\n@layer utilities {\n    .h-mobile {\n        height: calc(100vh - 4.75rem);\n    }\n\n    .h-desktop {\n        height: calc(100vh - 14.25rem);\n    }\n}\n\n.header-list {\n    margin-bottom: 6.6rem;\n}\n\n@media (max-width: 320px) {\n    .mobile-bg {\n        clip-path: polygon(0 154%, 100% 0, 100% 100%, 0% 100%);\n    }\n}\n\n@media (max-width: 576px) {\n    .mobile-bg {\n        clip-path: polygon(0 87%, 100% 0, 100% 100%, 0% 100%);\n    }\n}\n\n@media (max-width: 768px) {\n    .mobile-bg {\n        clip-path: polygon(0 77%, 100% 0, 100% 100%, 0% 100%);\n    }\n}\n\n.slick-arrow {\n    display: none !important;\n}\n\n@media (max-width: 768px) {\n    .slide {\n        width: 100% !important;\n        display: flex !important;\n    }\n}\n\n@media (min-width: 769px) {\n    .slide {\n        max-width: 47.8rem !important;\n        display: flex !important;\n    }\n}\n\n.slick-disable {\n    .slide-button {\n        background: #000;\n    }\n}\n\n.current-slide {\n    z-index: 20;\n}\n\n.select-placeholder-text {\n    color: pink;\n}\n\n.pac-container {\n    position: fixed !important;\n    z-index: 1000;\n}\n\na {\n    color: #951F1D;\n}\n\nli > a {\n    color: #777777;\n}\n\nli > a:hover {\n    color: #951F1D;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
